import React from 'react';
import {
  BasemapLayers,
  GeolocationLayer,
  DrawLayer,
  Map,
  MapLoadingPlaceHolder,
} from '@agissc/ktag-map';
import Toolbar from '../components/toolbar/Toolbar';
import ToolDialog from '../components/tooldialog/ToolDialog';
import SearchResultLayer from '../tools/map/SearchResultLayer';
import ViewControl from '../tools/map/ViewControl';
import Scalebar from '../components/locationDisplay/locationDisplay';
import Navigation from '../components/navigation/Navigation';
import Flyin from '../components/flyin/Flyin';
import useAppState from '../AppStore';
import useDisplaySize from '../useDisplaySize';
import HeaderMobile from '../components/mobile/HeaderMobile';
import ToolbarMobile from '../components/mobile/ToolbarMobile';
import Notifications from '../components/notification/Notification';
import PrintPreview from '../tools/print/PrintPreview';
import { INFO_BOX_ANCHOR_ID } from '../components/infoBox/InfoBox';
import ResetNotification from '../tools/notification/ResetNotification';
import IdentifySpotlightOverlay from '../tools/identify/IdentifySpotlightOverlay';
import ErrorBoundary from '../utils/errorBoundaries/ErrorBoundary';
import PreviewLayer from '../tools/mapContent/PreviewLayer';
import TopicLayers from '../tools/mapContent/TopicLayers';
import { ProtectedMapContentNotifications } from '../tools/mapContent/ProtectedMapContentNotifications';
import TopicLayerNotifications from '../tools/notification/TopicLayerNotifications';
import ErrorTopicLayerNotifications from '../tools/notification/ErrorTopicLayerNotifications';
import AttributeSearchResultLayer from '../tools/map/AttributeSearchResultLayer';
import TrackInitialLayers from '../utils/tracking/TrackInitialLayers';
import { TrackLogin, TrackSesionExpired } from '../utils/tracking/TrackLogin';
import useDraw from '../tools/draw/useDraw';
import InitHandler from '../tools/initHandler/InitHandler';
import BasemapNotFoundNotification from '../tools/mapContent/BasemapNotFoundNotification';
import StartUpModal from '../components/modal/StartUpModal';

const GisBrowser = () => {
  const geoLocationStatus = useAppState((state) => state.geolocationStatus);
  const viewCollapse = useAppState((state) => state.viewCollapse);
  const previewLayer = useAppState((state) => state.previewLayer);
  const loadingLayers = previewLayer ? [previewLayer] : [];
  const { isSmallScreen } = useDisplaySize();
  useDraw();

  return (
    <ErrorBoundary>
      <ProtectedMapContentNotifications />
      <div className="gisbrowser">
        {!isSmallScreen && (
          <div className="tool-container">
            <Toolbar />
            {!viewCollapse && <ToolDialog />}
          </div>
        )}
        {isSmallScreen && (
          <>
            <HeaderMobile />
            <ToolbarMobile />
          </>
        )}
        <StartUpModal />
        <ResetNotification />
        <TopicLayerNotifications />
        <ErrorTopicLayerNotifications />
        <TrackLogin />
        <TrackSesionExpired />
        <TrackInitialLayers />
        <div className="map-container">
          {isSmallScreen && <ToolDialog />}
          <div className="map-container__wrapper" data-component="MapContainer">
            <Map>
              <MapLoadingPlaceHolder extraLayers={loadingLayers} />
              <div id={INFO_BOX_ANCHOR_ID} />
              <div className="hud-container">
                <div className="hud-container__wrapper">
                  <div className="hud-container__bottom">
                    <Navigation />
                    <Scalebar />
                  </div>
                </div>
              </div>
              <InitHandler />
              <Notifications />
              <ViewControl />
              <IdentifySpotlightOverlay />
              <SearchResultLayer />
              <AttributeSearchResultLayer />
              <DrawLayer />
              <PreviewLayer />
              <PrintPreview />
              <TopicLayers />
              <BasemapLayers />
              <BasemapNotFoundNotification />
              {geoLocationStatus === 'enable' && (
                <GeolocationLayer zoomToGeolocation={11} />
              )}
            </Map>
            {!viewCollapse && <Flyin />}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default GisBrowser;
